import { ActionTypes, AppActions } from './types';

const calculatePriceSum = (configurationList) =>
  configurationList.reduce((result, { calculation }) => result + (calculation?.total || 0), 0);

const initialState = {
  configurationList: [],
  configurationListPriceSum: 0,
  userImages: {},
  contextMenu: {
    open: false,
    top: 0,
    left: 0,
    target: {},
  },
  clickToAddDoorHintState: {
    show: false,
    top: 0,
    left: 0,
  },
};

const AppReducer = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case ActionTypes.ADD_CONFIGURATION_TO_LIST: {
      const configurationList = [
        ...state.configurationList.filter(({ temporary }) => !temporary),
        action.configuration,
      ];
      const priceSum = calculatePriceSum(configurationList);
      return {
        ...state,
        configurationList,
        configurationListPriceSum: priceSum,
      };
    }
    case ActionTypes.REMOVE_CONFIGURATION_FROM_LIST: {
      const { configurationCode } = action;
      const configurationList = state.configurationList.filter(({ code }) => code !== configurationCode);
      const priceSum = calculatePriceSum(configurationList);
      const userImages = { ...state.userImages };
      delete userImages[configurationCode];
      return {
        ...state,
        configurationList,
        configurationListPriceSum: priceSum,
        userImages,
      };
    }
    case ActionTypes.SET_USER_IMAGE_FOR_CONFIGURATION: {
      const { configurationCode, file } = action;
      return {
        ...state,
        userImages: {
          ...state.userImages,
          [configurationCode]: file,
        },
      };
    }
    case ActionTypes.SET_CONTEXT_MENU_STATE: {
      return {
        ...state,
        contextMenu: action.payload,
      };
    }
    case ActionTypes.REMOVE_USER_IMAGE_FOR_CONFIGURATION: {
      const userImages = { ...state.userImages };
      delete userImages[action.configurationCode];
      return {
        ...state,
        userImages,
      };
    }
    case ActionTypes.SET_CLICK_TO_ADD_DOOR_HINT_STATE: {
      return {
        ...state,
        clickToAddDoorHintState: action.payload,
      };
    }
    default:
      return state;
  }
};

export default AppReducer;
